import React from 'react';
import $ from "jquery";
import { Button, Dropdown } from 'semantic-ui-react';


import View from './View';
import Title from '../../title';
import Server from '../../../functions/server';

export default class ServiceHistory extends React.Component {

  state = {
    machine: [], history: []
  }

  componentDidMount() {
    this.getMachineAndServiceType();
  }

  getMachineAndServiceType = () => {
    let context = this;
    this.setState({ load: true, message: 'getting customer!!!' })
    $.ajax({
        type: 'POST',
        url: Server()+'machinecustomer/GetmachineServiceType.php',
        success: function(data) {
            console.log(data);
            try {
                data = JSON.parse(data);
                context.setState({ machine: data, load: false, viewMachine: true });
            } catch (e) {
                alert('Error')
                context.setState({ load: false });
            }
        },
        error: function(e) {
            alert('Try again!!')
            context.setState({ load: false });
        }
    });
  }

  selectMachine = (f, { value }) => {
    this.setState({ addmachine: value })
  }
  
  machineOption = () => {
    let machine = this.state.machine;
    let option = [];
    machine.map((c) => {
      option.push({ key: c.machine+"->"+c.name, text: c.machine+"->"+c.name, value: c.id+"->"+c.machineid+"->"+c.machine+"->"+c.name }) 
    })
    return option;
  }

  getHistory = () => {
    let context = this;
    let { addmachine } = this.state;
    let machine = addmachine.split('->')[1];
    let servicetype = addmachine.split('->')[0];
    let machinename = addmachine.split('->')[2];
    let servicetypename = addmachine.split('->')[3];
    $.ajax({
      type: 'POST', data: { machine, servicetype, machinename, servicetypename },
      url: Server()+'machine/ServiceHistory/GetHistory.php',
      success: function(data) {
          console.log(data);
          console.log('--------------------------------');
          try {
              data = JSON.parse(data);
              console.log(data.header);
              context.setState({ history: data, load: false });
          } catch (e) {
              alert('Error')
              context.setState({ load: false });
          }
      },
      error: function(e) {
          alert('Try again!!')
          context.setState({ load: false });
      }
  });
  }

  render() {
    let machineOption = this.machineOption();
    return (
      <div>
        <Title title='Service History' openDrawer={this.props.openDrawer}/>
        <div style={{margin: '1%'}}>
          <div style={{display: 'flex', width: '100%'}}>
            <div style={{width: '25%'}}>
              <b>Select Machine</b><br/>
              <Dropdown placeholder='Machine' 
                onChange={this.selectMachine} 
                search selection fluid
                options={machineOption} value={this.state.addmachine} />
            </div>
            <div>
              <br/>
              <Button onClick={this.getHistory}>Submit</Button>
            </div>
          </div>
          <br/>
          <View history={this.state.history} />
        </div>
      </div>
    );
  }

}